var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.value || !!_vm.excludeWord,
        label: "フリーワード検索",
      },
    },
    [
      _c("div", { staticClass: "boss-layout boss-layout-vertical" }, [
        _c("div", [
          _c("div", { staticClass: "boss-separated-small" }, [
            _c(
              "div",
              {
                staticClass:
                  "boss-layout boss-layout-start boss-layout-gap-large",
              },
              [
                _c("div", [_c("label", [_vm._v("絞り込みワード")])]),
                _vm._v(" "),
                _vm._l(_vm.operatorOption, function (option, i) {
                  return _c(
                    "label",
                    {
                      key: i,
                      staticClass: "pega-input",
                      attrs: { "data-test": "option-" + i },
                    },
                    [
                      _c("input", {
                        staticClass: "boss-input-checkbox",
                        attrs: { type: "radio", name: "free-word" },
                        domProps: {
                          checked: _vm.operator === option.key,
                          value: option.key,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit(
                              "update:operator",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(_vm._s(option.label) + "\n          "),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-layout boss-layout-start" }, [
            _c(
              "div",
              { staticClass: "boss-layout-item-grow" },
              [
                _c("input", {
                  staticClass: "boss-input boss-input-fill",
                  class: { "is-invalid-input": !!_vm.freeWordErrorMessage },
                  attrs: {
                    type: "text",
                    placeholder:
                      "複数入力時は半角・全角スペースで区切ってください",
                    "data-test": "free-word",
                  },
                  domProps: { value: _vm.value },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("input", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                !!_vm.freeWordErrorMessage
                  ? _c("validation-label", {
                      attrs: {
                        label: _vm.freeWordErrorMessage,
                        "data-test": "free-word-validation",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "margin-right-1" }, [
            _vm._v("除外キーワード"),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "boss-annotation-text" }, [
            _vm._v(
              "\n        ※いずれかのキーワードを含む対象を除外します\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-layout boss-layout-start" }, [
            _c(
              "div",
              { staticClass: "boss-layout-item-grow" },
              [
                _c("input", {
                  staticClass: "boss-input boss-input-fill",
                  class: { "is-invalid-input": !!_vm.excludeWordErrorMessage },
                  attrs: {
                    type: "text",
                    placeholder:
                      "複数入力時は半角・全角スペースで区切ってください",
                    "data-test": "exclude-word",
                  },
                  domProps: { value: _vm.excludeWord },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "update:excludeWord",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                !!_vm.excludeWordErrorMessage
                  ? _c("validation-label", {
                      attrs: {
                        label: _vm.excludeWordErrorMessage,
                        "data-test": "exclude-word-validation",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }